
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1977_7235)","fill":"#262626"}},[_c('path',{attrs:{"d":"M17.25.643H.75a.752.752 0 00-.75.75v11.25c0 .412.338.75.75.75h3v3a.75.75 0 001.23.577l4.29-3.577h7.98c.413 0 .75-.338.75-.75V1.393a.752.752 0 00-.75-.75zm-.75 11.25H9a.754.754 0 00-.48.172l-3.27 2.723v-2.153a.752.752 0 00-.75-.75h-3V2.143h15v9.75z"}}),_c('path',{attrs:{"d":"M11.25 6.643H12v.75c0 .412.338.75.75.75s.75-.338.75-.75v-.75h.75c.412 0 .75-.338.75-.75a.752.752 0 00-.75-.75h-.75v-.75a.752.752 0 00-.75-.75.752.752 0 00-.75.75v.75h-.75a.752.752 0 00-.75.75c0 .412.338.75.75.75zM3.75 11.143h6c.412 0 .75-.338.75-.75v-.75a3.003 3.003 0 00-2.197-2.88C8.73 6.35 9 5.78 9 5.143a2.257 2.257 0 00-2.25-2.25 2.257 2.257 0 00-2.25 2.25c0 .637.27 1.215.697 1.62A2.996 2.996 0 003 9.643v.75c0 .412.337.75.75.75zm3-6.75c.412 0 .75.337.75.75 0 .412-.338.75-.75.75a.752.752 0 01-.75-.75c0-.413.338-.75.75-.75zM6 8.143h1.5c.825 0 1.5.675 1.5 1.5H4.5c0-.825.675-1.5 1.5-1.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1977_7235"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    